<template>
  <div class="container" v-loading.fullscreen="loading" element-loading-background="rgba(0, 0, 0.5)" element-loading-text="加载中...">
    <div class="container-content">
      <div class="content-title">评测人员</div>
      <div class="content-item">
        <OrganizationTree @nodeClick="nodeClick"></OrganizationTree>
        <div class="content-right">
          <div class="right-title">人员</div>
          <div class="query">
            <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
          </div>
          <div class="table">
            <MyTable :table-options="tableOptions" border max-height="60vh" @selection-change="(val) => (printList = val)">
              <template #qrCode="{ row }">
                <vue-qr v-if="row.id" :margin="0" :size="400" style="cursor: pointer;width: 40px;" :text="'TEST@'+row.id" :callback="(url) => { row.previewQrUrl = url }" @click="row.qrCodeVisible = true"></vue-qr>
                <Dialog width="400" v-model="row.qrCodeVisible" title="二维码预览" top="15vh">
                  <img :src="row.previewQrUrl" alt="Preview Image" style="width: 100%" />
                </Dialog>
              </template>
              <template #isEvaluation="{ row }">
                {{ row.isEvaluation ? '已评测' : '未评测' }}
              </template>
              <template #handler="{ row }">
                <div>
                  <el-button
                    style="color: #6fcaf7"
                    icon="Edit"
                    link
                    @click="click_Row_edit(row)"
                    >编辑</el-button>
                  <ConfirmButton
                    style="color: #6fcaf7"
                    icon="Delete"
                    link
                    @confirm="click_Row_delete(row)"
                    >删除</ConfirmButton>
                </div>
                 <div>
                 <el-button
                    v-if="row.isEvaluation"
                    style="color: #6fcaf7"
                    icon="View"
                    link
                    @click="click_Report(row)"
                    >查看趋势</el-button>
                </div>
              </template>
            </MyTable>
          </div>
        </div>
      </div>
      <MyPagination :params="paginationParams" :total="total" @get-list="getTesterList" ref="paginationRef" />
    </div>
    <!-- 添加用户 -->
    <Dialog
      width="50%"
      v-model="dialogAddUserVisible"
      title="用户"
      top="5vh"
     >
      <MyForm
        class="add-user-form"
        :formOptions="addUserForm"
        :inline="true"
        ref="myFormRef"
        label-width="auto"
      >
        <template #areaArr="{ formData }">
          <ChinaArea :class="{'form-readonly':readonly}" v-model="formData.areaArr" />
        </template>
        <template #upload="{ formData }">
            <div style="display: flex; gap: 20px; align-items: center;margin-bottom: 10px;">
              <el-upload ref="uploadRef" action="#" :http-request="FaceUpload" :show-file-list="false" :before-upload="handleBeforeUpload">
                  <!-- <template #trigger> -->
                    <el-button type="primary" size="large">上传图片</el-button>
                  <!-- </template> -->
              </el-upload>
               <el-button size="large"  icon="Camera" @click="click_takePhoto">拍照</el-button>
            </div>
            <div style="display: flex;align-items: center;">
                 <div v-if="faceShow" style="font-size: 16px;color: #67C23A;">人脸图片已上传</div>
                 <div v-else style="font-size: 16px;">人脸图片未上传</div>
                 <div v-if="faceShow" style="margin-left: 12px;">
                   <el-button @click="showPreview = true" icon="View"> 查看</el-button>
                      <el-image-viewer
                      v-if="showPreview"
                      :url-list="srcList"
                      show-progress
                      @close="showPreview = false"
                     />
                 </div>
            </div>
        </template>
      </MyForm>
      <div class="submit-buttons">
        <el-button @click="dialogAddUserVisible = false">取消</el-button>
        <el-button @click="click_addUser_confirm">确定</el-button>
      </div>
    </Dialog>
    <!--打印-->
    <PrintList
      ref="PrintListRef"
      :list="printList"
      :printFields="selectedPrintFields"
      v-model="printVisible"
      v-if="printVisible"
    />
   <!-- 打印字段配置弹窗 -->
    <Dialog
      width="600px"
      v-model="printConfigVisible"
      title="打印字段配置"
      top="5vh"
      @close="handlePrintDialogClose"
    >
      <div class="print-config-wrap">
        <div class="tip">点击勾选字段，勾选顺序即为打印展示顺序</div>
        <div class="field-item" v-for="item in printFieldList" :key="item.prop">
          <el-checkbox v-model="item.checked" @change="handleFieldCheckChange(item)">
            {{ item.label }}
            <span v-if="item.checked" class="order-num">
              {{ selectedPrintFields.findIndex(i => i.prop === item.prop) + 1 }}
            </span>
          </el-checkbox>
        </div>
        <!-- 勾选顺序预览 -->
        <div style="margin-top:16px;color:#666">
         打印顺序预览：
          <span v-if="selectedPrintFields.length">
            {{ selectedPrintFields.map(i=>i.label).join(' → ') }}
          </span>
          <span v-else>未选择字段</span>
        </div>
      </div>
      <div class="submit-buttons" style="margin-top:20px;text-align:right">
        <el-button @click="printConfigVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmPrintConfig">确认打印</el-button>
      </div>
    </Dialog>
    <!-- 模板导入 -->
    <Dialog
      width="50%"
      v-model="uploadVisible"
      title="模板导入"
      top="5vh"
    >
      <el-upload ref="uploadRef" action="#" drag :http-request="httpRequest" :show-file-list="false">
        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
        <div class="el-upload__text">
         拖动文件或<em>点击上传</em>
        </div>
      </el-upload>
    </Dialog>
    <Dialog
      width="50%"
      v-model="takePhotoVisible"
      title="拍照"
      top="5vh"
    >
    <takePhoto :cameraConfig="dataConfig" @upload-success="handleUploadSuccess"></takePhoto>
    </Dialog>
  </div>
</template>
<script setup>
import { computed, nextTick, reactive, ref,onMounted } from "vue";
import MyTable from "@/components/Global/MyTable.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import ConfirmButton from "@/components/Common/ConfirmButton.vue";
import OrganizationTree from "@/components/Common/OrganizationTree.vue";
import organizationApi from "@/api/organization";
import dayjs from "dayjs";
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import ChinaArea from "@/components/Common/ChinaArea.vue";
import PrintList from "./PrintList.vue";
import takePhoto from "./takePhoto.vue";
import uploadApi from "@/api/upload";
import { ElLoading, ElMessage } from "element-plus";
import {getDepartment} from "@/api/department"
import { useRouter } from "vue-router";
const router = useRouter();
const click_Report=(row)=>{
  console.log(row)
    router.push({
    path: '/userManagement/details',
    query: {id: row.id }
    })
}
const showPreview=ref(false)
const handleUploadSuccess=(data)=>{
takePhotoVisible.value=false
faceShow.value=data
}
const takePhotoVisible=ref(false)
const dataConfig=ref({})
const click_takePhoto=()=>{
  takePhotoVisible.value=true
}
const faceShow=ref(false)
const handleBeforeUpload=(file)=>{
        // 判断文件类型是否为图片
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        ElMessage.warning("只能上传图片文件！")
        return false; // 返回 false 会阻止上传
      }
      // 可选：限制文件大小（例如 2MB）
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        ElMessage.warning("图片大小不能超过 2MB！")
        return false;
      }
      return true; // 校验通过，继续上传
}
// 上传人脸
const FaceUpload=(fileInfo)=>{
       let loading= ElLoading.service({
          lock: true,
          text: "上传中...",
          background: "rgba(0, 0, 0, 0.5)",
        });
      console.log(fileInfo)
        const { formData } = myFormRef.value;
        const F = new FormData();
        const { file } = fileInfo;
        F.append("file", file);
        F.append("FaceEngineType",1)
        F.append("TesterId",formData.id)
        uploadApi.personnelUploadFile(F).then(res=>{
            faceShow.value=true
            console.log(res)
            loading.close();
        }).catch(()=>{
           faceShow.value=false
            loading.close();
        })
}
const loading = ref(false);
// getDepartmentList();
// 左侧节点点击事件
const currentUnit = ref({});
const nodeClick = (data) => {
  paginationParams.OrganizationId = data.id;
  currentUnit.value = data;
  getDepartmentList();
};
// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "Input",
      label: "姓名：",
      prop: "Name",
      attrs: {
        placeholder: "请输入",
      },
    },
    {
      type: "Input",
      label: "关键字：",
      prop: "Key",
      attrs: {
        placeholder: "请输入学号/手机号",
      },
    },
    {
      type: "Input",
      label: "组织信息：",
      prop: "StrValue",
      attrs: {
        placeholder: "请输入",
      },
    },
    {
      type: "Select",
      label: "评测状态：",
      prop: "IsEvaluation",
      options:[
        { label: "全部", value: '' },
        { label: "已评测", value: true },
        { label: "未评测", value: false },
      ],
      attrs: {
        emptyValues: [null, undefined],
        filterable: false,
      }
    },
    [
      {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
        },
        events: {
          click(formData) {
            Object.assign(paginationParams, formData);
          },
        },
      },
      {
        type: "Button",
        value: "导出",
        attrs: {
          icon: "i-export",
        },
        events: {
          click(formData) {
            exportExcel();
          },
        },
      },
      {
        type: "Button",
        value: "重置",
        attrs: {
          icon: "Refresh",
        },
        events: {
          click(formData,formRef) {
            formRef.resetFields();
            Object.assign(paginationParams,formData)
          },
        },
      },
      {
        type: "Button",
        value: "新增用户",
        attrs: {
          icon: "Plus",
        },
        events: {
          click(formData) {
            addTester();
          },
        },
      },
      {
        type: "Button",
        value: "打印",
        attrs: {
          icon: "Download",
        },
        events: {
          click(formData) {
            handlePrint();
          },
        },
      },
    ],
    [
      {
        type: "Button",
        value: "模板导入",
        attrs: {
          icon: "i-import",
        },
        events: {
          click(formData) {
            if(!currentUnit.value.id){
              return ElMessage.warning("请先选择组织");
            }
            uploadVisible.value = true;
          },
        },
      },
      {
        type: "Button",
        value: "下载模板",
        attrs: {
          icon: "Download",
        },
        events: {
          click(formData) {
            if(!currentUnit.value.id){
              return ElMessage.warning("请先选择组织");
            }
            uploadApi.downloadTemp(currentUnit.value.id).then(res => {
              const aLink = document.createElement('a')
              aLink.href = res.data
              const fileName = res.data.split('/').pop()
              aLink.setAttribute('download',fileName)
              aLink.click()
              aLink.remove();
            });
          },
        },
      },
    ],
  ],
});
const tableOptions = reactive({
  colList: [
    { type: "selection" },
    { label: "序号", type: "index", width: 70 },
    { label: "用户姓名", prop: "name",width: 100 },
    { label: "电话", prop: "phone",width: 140  },
    { label: "编号", prop: "numberId" },
    { label: "部门/学院", prop: "strValue2" },
    { label: "年级", prop: "strValue3" },
    { label: "班级", prop: "strValue4" },
    { label: "创建时间", prop: "creationTime" },
    { label: "二维码", type: "slot", slot_name: "qrCode" },
    { label: "评测状态", type: "slot", slot_name: "isEvaluation" },
    { label: "操作", type: "slot", slot_name: "handler", width: 200 },
  ],
  tableData: [],
});
const paginationParams = reactive({
  OrganizationId: "",
})
const paginationRef = ref(null);
const total = ref(0);
const getTesterList = (params = paginationRef.value.getList_params) => {
  if(!params.OrganizationId){
    return;
  }
  organizationApi.getEvaluationList(params).then((res) => {
    total.value = res.data.totalCount;
    tableOptions.tableData = res.data.items.map(item=>{
      item.organizationName = currentUnit.value.name;
      item.creationTime = dayjs(item.creationTime).format("YYYY-MM-DD HH:mm:ss");
      return item;
    });
  })
}
// 添加用户
const dialogAddUserVisible = ref(false);
const itemList = computed(() => {
  const base = [
    {
      type: "Input",
      label: "姓名：",
      prop: "name",
    },
    {
      type: "Input",
      label: "编号：",
      prop: "numberId",
    },
    {
      type: "Input",
      label: "电话：",
      prop: "phone",
    },
    {
      type: "Radio",
      label: "性别：",
      prop: "sex",
      defaultValue: 1,
      options: [
        { label: "男", value: 1 },
        { label: "女", value: 2 },
      ],
    },
    {
      type: "Input",
      label: "电子邮箱：",
      prop: "email",
    },
    {
      type: "Date",
      label: "出生日期：",
      prop: "birth",
      attrs: {
        valueFormat: "YYYYMMDD",
        format: "YYYYMMDD",
        type: "date",
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
    },
    {
      type: "Input",
      label: "所属组织：",
      prop: "organizationName",
      attrs: {
        readonly: true,
      },
    },
    {
      type: "Input",
      label: "职业：",
      prop: "career",
    },
    {
      type: "Select",
      label: "所属部门：",
      prop: "departmentName",
      options: departmentList,
    },
    {
      type: "Slot",
      label: "所在城市：",
      slot_name: "areaArr",
      prop: "areaArr",
    },
    {
      type: "Slot",
      label: "上传：",
      slot_name: "upload",
      prop: "upload",
      hidden: itemFlag.value,
    },
  ];
  return base;
});
const readonly = ref(false); //只读
const itemFlag=ref(false)
const addUserForm = reactive({
  itemList: itemList,
  rules: {
    name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
    numberId: [{ required: true, message: "编号不能为空", trigger: "blur" }],
    phone: [
      // { required: true, message: "手机号不能为空", trigger: "blur" },
      { pattern: /^1\d{10}$/, message: "手机号格式不正确", trigger: "blur" },
    ],
  },
  commonAttrs: {
    readonly,
  },
});
// 打开添加用户模态框
const addTester = async() => {
  if(!currentUnit.value?.id){
    return ElMessage.warning("请先选择组织");
  }
  readonly.value = false;
  itemFlag.value=true
  dialogAddUserVisible.value = true;
  await nextTick();
  const { formData } = myFormRef.value;
  formData.organizationName = currentUnit.value.name;
};
// 添加用户确认
const myFormRef = ref(null);
const click_addUser_confirm = () => {
  if(readonly.value){
    dialogAddUserVisible.value = false;
    return;
  }
  const { formRef, formData } = myFormRef.value;
  console.log(" formData:", formData)
  formRef.validate(async(valid) => {
    if (valid) {
      if(formData.areaArr){
        formData.province = formData.areaArr[0];
        formData.city = formData.areaArr[1];
        formData.area = formData.areaArr[2];
      }
      formData.organizationId = currentUnit.value.id;
      if (formData.birth) {
        formData.birth = formData.birth.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
      }
      formData.id ? await organizationApi.editTester(formData)
      : await organizationApi.addTester(formData)
      
      ElMessage.success(`${formData.id ? "编辑" : "添加"}成功`);
      dialogAddUserVisible.value = false;
      getTesterList();
    }
  })
};
const click_Row_view = async(row) => {
  readonly.value = true;    
  row.areaArr = [row.province, row.city, row.area];
  dialogAddUserVisible.value = true;
  await nextTick();
  const { formData } = myFormRef.value;
  Object.assign(formData, row);
}
const srcList =ref([])
const click_Row_edit = async(row) => {
  dataConfig.value=row
  readonly.value = false;
  itemFlag.value=false
  row.areaArr = [row.province, row.city, row.area];
  dialogAddUserVisible.value = true;
  await nextTick();
  const { formData } = myFormRef.value;
  Object.assign(formData, row);
  uploadApi.testerEvaluationFace({TesterId:row.id,organizationId:row.organizationId}).then(res=>{
          if(res.data.items.length>0){
             faceShow.value=true
             uploadApi.getFileData(res.data.items[0].faceFileId).then(res1=>{
               srcList.value=[res1.data.fullFileUrl]        
             })
          }else{
             faceShow.value=false
          }
   })
}
const click_Row_delete = (row) => {
  organizationApi.delTester(row.id).then((res) => {
    ElMessage.success("移除成功");
    getTesterList();
  })
}
//打印
const printConfigVisible=ref(false)
const printList = ref([]);
const PrintListRef = ref(null);
const printVisible = ref(false);
// ========== 打印字段配置【完整修复】 =========
// 可选打印字段，label展示名称，prop对应row字段
const printFieldList = ref([
  { label: "用户姓名", prop: "name", checked: true },
  { label: "性别", prop: "sexText", checked: true },
  { label: "编号", prop: "numberId", checked: true },
  { label: "班级", prop: "strValue4", checked: false },
  { label: "电话", prop: "phone", checked: false },
  { label: "部门/学院", prop: "strValue2", checked: false },
  { label: "年级", prop: "strValue3", checked: false },
]);
// 保存【勾选的prop】
const savedCheckedProps = ref([])
// 保存【顺序prop数组】
const savedOrderProps = ref([])
// 选中的字段（顺序=勾选先后，用于预览+打印）
const selectedPrintFields = ref([]);

// 打开弹窗前：恢复 printFieldList 的勾选状态，并且恢复selectedPrintFields顺序
const initPrintDefaultFields = () => {
  // 1. 恢复勾选状态
  if(savedCheckedProps.value.length > 0){
    printFieldList.value.forEach(field => {
      field.checked = savedCheckedProps.value.includes(field.prop)
    })
  }

  // 2. 获取当前勾选的所有字段
  const allCheckedItems = printFieldList.value.filter(item => item.checked)

  if (savedOrderProps.value.length > 0) {
    const orderedList = []
    savedOrderProps.value.forEach(prop => {
      const findItem = allCheckedItems.find(p => p.prop === prop)
      if (findItem) {
        orderedList.push(findItem)
      }
    })
    // 新增勾选不在历史顺序里的放末尾
    const newCheckedItems = allCheckedItems.filter(item => !savedOrderProps.value.includes(item.prop))
    selectedPrintFields.value = [...orderedList, ...newCheckedItems]
  } else {
    selectedPrintFields.value = allCheckedItems
  }
}

// 勾选事件，防止重复push
const handleFieldCheckChange = (item) => {
  if (item.checked) {
    const exist = selectedPrintFields.value.some(i => i.prop === item.prop)
    if (!exist) {
      selectedPrintFields.value.push(item);
    }
  } else {
    const index = selectedPrintFields.value.findIndex(i => i.prop === item.prop)
    if (index > -1) selectedPrintFields.value.splice(index, 1)
  }
}

// 保存当前勾选和顺序到缓存变量
const savePrintFieldState = () => {
  savedCheckedProps.value = printFieldList.value.filter(p => p.checked).map(p => p.prop)
  savedOrderProps.value = selectedPrintFields.value.map(i => i.prop)
}

// 确认打印
const confirmPrintConfig = () => {
  if (selectedPrintFields.value.length === 0) {
    return ElMessage.warning("请至少勾选一个打印字段");
  }
  savePrintFieldState()
  printConfigVisible.value = false;
  printVisible.value = true;
  nextTick(() => {
    PrintListRef.value.print();
  });
};

// 弹窗关闭事件（取消、点击遮罩关闭都触发，自动保存状态）
const handlePrintDialogClose = () => {
  savePrintFieldState()
}

// 打开打印配置弹窗
const handlePrint = () => {
  if (!printList.value.length) {
    return ElMessage.warning("请选择要打印的数据");
  }
  initPrintDefaultFields()
  printConfigVisible.value = true;
};
// ========== end打印 =========

// 模板导入
const uploadVisible = ref(false);
const httpRequest = (fileInfo) => {
  const F = new FormData();
  const { file } = fileInfo;
  F.append("file", file);
  loading.value = true;
  uploadApi.importTemp(currentUnit.value.id,F).then(res => {
    uploadVisible.value = false;
    ElMessage.success("导入成功");
    getTesterList();
  }).finally(() => {
    loading.value = false;
  })
}
const exportExcel = () => {
  if(!currentUnit.value.id){
    return ElMessage.warning("请先选择组织");
  }
  loading.value = true;
  organizationApi.exportExcel({
    ...paginationParams,
    ...paginationRef.value.getList_params,
  }).then(res => {
    const aLink = document.createElement('a')
    const blob = new Blob([new Uint8Array(
      atob(res.data)
        .split("")
        .map((c) => c.charCodeAt(0))
    )], { type: 'application/vnd.ms-excel,charset=utf-8' })
    aLink.href = URL.createObjectURL(blob)
    aLink.setAttribute('download',`${currentUnit.value.name}.xlsx`)
    aLink.click()
    URL.revokeObjectURL(aLink.href); 
    aLink.remove();
  }).finally(() => {
    loading.value = false;
  })
}
const departmentList = ref([]);
const getDepartmentList = () => {
  getDepartment({organizationId:paginationParams.OrganizationId,SkipCount:0,MaxResultCount: 1000}).then(res=>{
    departmentList.value = res.data.items.map(item=>{
      return {
        label: item.name,
        value: item.name,
        ...item
      }
    });
  })
}
onMounted(()=>{
  // 页面初始化保存默认勾选状态
  savedCheckedProps.value = printFieldList.value.filter(p => p.checked).map(p=>p.prop)
  savedOrderProps.value = printFieldList.value.filter(p => p.checked).map(p=>p.prop)
})
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  .container-content {
    .content-item {
      display: flex;
      min-height: 60vh;
      .content-right {
        flex: 1;
        overflow: hidden;
        .right-title {
          background: #134e92;
          height: 40px;
          line-height: 40px ;
          color: #66baec;
          display: flex;
          justify-content: space-between;
          padding-left: 20px;
        }
        .query {
          background: #03386a;
          padding: 0 20px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #66baec;
          .search-form {
            padding-top: 20px;
          }
        }
      }
    }
  }
  .form {
    .el-input {
      width: 270px;
    }
  }
}
.add-user-form {
  padding: 0 50px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  :deep(){
    .el-input,.el-select {
      width: 100%;
      height: 40px;
    }
    .el-select__wrapper{
      width: 100%;
      height: 100%;
    }
    .form-readonly{
      pointer-events: none;
    }
  }
}
.print-config-wrap{
  .field-item{
    margin:8px 0;
    display:flex;
    align-items:center;
  }
  .order-num {
    display: inline-block;
    margin-left: 10px;
    background: #409eff;
    color: #fff;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    text-align: center;
    font-size:12px;
    line-height:20px;
  }
}
</style>
